import api from '@shared/services/api.js';

export const getLoans = async payload => {
  return api.postJson('/sell/api/loans/search', payload);
};
